import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import noPhoto from '../../assets/img/no_photo.png';
import {getArticle} from '../../actions/article';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor/index';
import {dateFormatUK} from '../../utils/commonFunctions';
import ArticleList from '../common/article/article-list';
import './style.css';
import RedirectToLogin from '../common/redirect-to-login';
import LinkedArticlesList from '../common/article/linked-articles-list';
import constants from './constants';

class ArticlePage extends Component {
  createArticleList = data => data.map(curr => ({
    id: curr.id.toString(),
    attributes: {
      ...curr
    }
  }));

  componentWillMount() {
    this.props.dispatch(getArticle(this.props.match.params.id));
    if (this.props.edit && this.props.isAdmin) {
      this.props.dispatch({type: 'TOGGLE_EDIT_CONTENT', payLoad: true});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.props.dispatch(getArticle(nextProps.match.params.id));
    }
  }
  componentWillUnmount() {
    this.props.dispatch({type: 'CLEAR_NEWS_ARTICLE'});
  }

  render() {
    const {
      area, latestNews, article, meta
    } = this.props;

    if (!article) {
      return <RedirectToLogin loginPath='/' requestedPath={window.location.pathname}/>;
    }

    let image = noPhoto;

    if (article.attributes && article.attributes.link.image != null) {
      // eslint-disable-next-line prefer-destructuring
      image = article.attributes.link.image;
    }

    let videoLink = null;

    if (article.attributes && article.attributes['video-link'] != null) {
      // eslint-disable-next-line prefer-destructuring
      videoLink = article.attributes['video-link'];
    }

    let gameLink = null;

    if (article.attributes && article.attributes['game-link'] != null) {
      // eslint-disable-next-line prefer-destructuring
      gameLink = article.attributes['game-link'];
    }

    let banner;

    if (article.attributes && article.attributes.link.banner != null) {
      // eslint-disable-next-line prefer-destructuring
      banner = article.attributes.link.banner;
    }

    let mobileImage;

    if (article.attributes && article.attributes.link['mobile-image'] !== null) {
      // eslint-disable-next-line prefer-destructuring
      mobileImage = article.attributes.link['mobile-image'];
    }

    const title = article.attributes
      ? article.attributes.title
      : '';
    const date = article.attributes
      ? dateFormatUK(article.attributes['display-from-date'])
      : '';
    const category = article.attributes
      ? article.attributes.category
      : { id: 0, name: '' };
    const renderDate = category.name.toLowerCase() !== 'about ignite' && category.name.toLowerCase() !== 'how to earn';

    const titleTextColor = article.attributes
      ? article.attributes['title-text-colour']
      : '#fff';

    const linkedArticles = article.attributes
      ? article.attributes['linked-articles']
      : [];

    const mobileScreen = window.innerWidth <= 480 && window.innerHeight <= 1097;
    const imageMinimumHeight = mobileScreen ? '360px' : '300px';

    return (
      <Grid bsClass="container" fluid className="article">
        {(area === 'retailer' || area === 'pre_login') && (
          <div>
            <Row className="article-banner" style={{ minHeight: !banner ? imageMinimumHeight : ''}}>
              <h1 style={{ color: titleTextColor }}>{title}</h1>
              {!mobileScreen && banner && <img src={banner} alt={`${title} banner image`} />}
              {mobileScreen && mobileImage && <img src={mobileImage} alt={`${title} mobile image`} />}
            </Row>
            <div className="user-inner-container">
              <Row>
                <div className="article-image-container-border">
                  <div className="article-image-container">
                    <img alt="Article" src={image}/>
                  </div>
                </div>
              </Row>
              <Row className="article-body">
                <Col md={(latestNews && latestNews.length > 0) ? 8 : 12} className="no-padding">
                  {videoLink && videoLink !== 'null' && (
                  <iframe
                    allow="autoplay; fullscreen"
                    allowfullscreen=""
                    frameborder="0"
                    height="360"
                    src={videoLink}
                    width="640"
                  />)}
                  {gameLink && gameLink !== 'null' && (
                  <iframe
                    frameborder="0"
                    height="900"
                    scrolling="yes"
                    src={gameLink}
                    width="900"
                  />)}
                  {meta && (
                    <InlineCKEditor
                      activeClass="content-editor"
                      config={{
                        width: '100%',
                        height: '100%'
                      }}
                      contents={meta.contents.length ? meta.contents[0] : ''}
                      identifier={meta.contents.length ? meta.contents[0].identifier : ''}
                      onContentSaved={() => this.props.dispatch({
                        type: 'TOGGLE_EDIT_CONTENT',
                        payLoad: false
                      })}
                    />
                  )}
                </Col>
                {(linkedArticles && linkedArticles.length > 0) && (
                  <Col md={4} className="no-padding">
                    <div className="article-related">
                      <h2>LINKED ARTICLES</h2>
                      <div className="article-related-separator" />
                      <LinkedArticlesList articles={linkedArticles} />
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        )}
        {(area !== 'retailer' && area !== 'pre_login') && (
          <div>
            <Row>
              <Col lg={12}>
                <Col md={3} sm={5}>
                  <Row>
                    <img alt="Article" className="article-image" src={image}/>
                  </Row>
                </Col>
                <Col md={9} sm={7}>
                  <Row>
                    <h2 className="title">
                      {title}
                    </h2>
                  </Row>
                  <Row>
                    <span>
                      {renderDate && date}
                    </span>
                  </Row>
                </Col>
              </Col>
            </Row>
            <Row>
              <Col className="content-page" lg={12}>
                {this.props.meta && (
                  <InlineCKEditor
                    activeClass="content-editor"
                    config={{
                      width: '100%',
                      height: '100%'
                    }}
                    contents={meta.contents.length ? meta.contents[0] : ''}
                    identifier={meta.contents.length ? meta.contents[0].identifier : ''}
                    onContentSaved={() => this.props.dispatch({
                      type: 'TOGGLE_EDIT_CONTENT',
                      payLoad: false
                    })}
                  />
                )}
              </Col>
            </Row>
            {(this.props.article.attributes && this.props.article.attributes['linked-articles'].length > 0) &&
            (!this.props.isAdmin && !this.props.isAdminRoute) && (
              <Row>
                <Col lg={12}>
                  <PageTitle ignoreForDoc>
                    Have you seen?
                  </PageTitle>
                </Col>
                <Col lg={12}>
                  <ArticleList articles={this.createArticleList(this.props.article.attributes['linked-articles'])} type={area}/>
                </Col>
              </Row>
            )}
          </div>
        )}
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  article: state.article.article,
  meta: state.article.meta,
  latestNews: state.latestNews.latestNews.filter(article => (
    !constants.excludedCategoryIds.includes(article.attributes.category.id)
  )),
  isAdmin: state.viewConfig.isAdmin,
  isAdminRoute: state.router.location.pathname.includes('admin'),
  edit: state.router.location.pathname.includes('edit-content')
});

export default connect(mapStateToProps)(ArticlePage);



// WEBPACK FOOTER //
// ./src/components/article/index.jsx